function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M33.27 11.3L39.07 23.04L40.23 25.4L42.83 25.78L55.79 27.66L46.41 36.81L44.53 38.64L44.98 41.23L47.19 54.14L35.6 48.05L33.27 46.82L30.94 48.05L19.35 54.14L21.56 41.23L22.01 38.64L20.12 36.81L10.74 27.66L23.71 25.78L26.31 25.4L27.47 23.04L33.27 11.3M22.99 20.83L0 24.17L16.63 40.39L12.71 63.28L33.27 52.47L53.83 63.28L49.91 40.39L66.54 24.17L43.55 20.83L33.27 0L33.27 0L22.99 20.83Z",
  id: "c2yh2KJeAL"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.84 23.25L59.64 25.97L46.76 39.17L49.8 57.8L33.88 49L17.97 57.8L21.01 39.17L8.13 25.97L25.93 23.25L33.88 6.3L41.84 23.25Z",
  id: "a2YKSjFwtL"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2yh2KJeAL",
  opacity: 1,
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2yh2KJeAL",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2YKSjFwtL",
  opacity: 1,
  fillOpacity: 1
}))));

function SvgStarFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 67 63",
    width: 67,
    height: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default ForwardRef;